// Utility functions for global loading that can be used anywhere in the app
// This provides a way to access global loading without React hooks

let globalLoadingContext = null;

export const setGlobalLoadingContext = (context) => {
  globalLoadingContext = context;
};

export const startGlobalLoading = (message = 'Loading...') => {
  if (globalLoadingContext && globalLoadingContext.startLoading) {
    globalLoadingContext.startLoading(message);
  }
};

export const stopGlobalLoading = () => {
  if (globalLoadingContext && globalLoadingContext.stopLoading) {
    globalLoadingContext.stopLoading();
  }
};

export const setGlobalLoading = (loading, message = 'Loading...') => {
  if (globalLoadingContext && globalLoadingContext.setLoading) {
    globalLoadingContext.setLoading(loading, message);
  }
};

// Wrapper for async functions with automatic loading management
export const withGlobalLoading = async (asyncFunction, message = 'Loading...') => {
  if (!globalLoadingContext) {
    console.warn('Global loading context not available, executing function without loading state');
    return await asyncFunction();
  }
  
  startGlobalLoading(message);
  try {
    const result = await asyncFunction();
    return result;
  } finally {
    stopGlobalLoading();
  }
};
